import './App.css';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { THEME_STORAGE_KEY } from './config';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import Footer from './components/layout/Footer';
import NewsFeed from './components/news/NewsFeed';
import ArticlePage from './components/news/ArticlePage';
import IndustryVoicesPage from './components/news/IndustryVoicesPage';
import SlotReviewsPage from './components/slots/SlotReviewsPage';
import SlotReviewPage from './components/slots/SlotReviewPage';
import AdminAiConsole from './components/admin/AdminAiConsole';
import AdminGate from './components/admin/AdminGate';
import TipsPage from './components/tips/TipsPage';
import { trackAdsConversion } from './utils/gtag';

const ADS_CONVERSION_SEND_TO = 'AW-11483276229/RXYwCOixx4wZEMXH0-Mq';

function AdsConversionTracker() {
  const location = useLocation();

  useEffect(() => {
    // Only fire in production, and never from admin routes.
    if (process.env.NODE_ENV !== 'production') return;
    if (location.pathname.startsWith('/admin')) return;
    // Fire conversion on each client-side navigation (pageview-style conversion).
    trackAdsConversion(ADS_CONVERSION_SEND_TO);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'light';
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
    // Default to light theme when no preference has been stored
    return 'light';
  });

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // ignore write errors
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <Router>
      <AdsConversionTracker />
      <div className="app-shell">
        <Header theme={theme} onToggleTheme={toggleTheme} />
        <main className="app-main">
          <div className="app-container">
            <div className="app-grid">
              <Routes>
                <Route path="/" element={<NewsFeed variant="home" />} />
                <Route path="/news" element={<NewsFeed variant="all" />} />
                <Route path="/news/:slug" element={<ArticlePage />} />
                <Route path="/industry-voices" element={<IndustryVoicesPage />} />
                <Route path="/slots" element={<SlotReviewsPage />} />
                <Route path="/slots/:slugOrId" element={<SlotReviewPage />} />
                <Route
                  path="/admin"
                  element={
                    <AdminGate>
                      <AdminAiConsole />
                    </AdminGate>
                  }
                />
                <Route path="/tips" element={<TipsPage />} />
              </Routes>
              <Sidebar />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;


